<template>
  <a-modal
    class="company-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    title="关联企业"
    @ok="$emit('onCancel')"
    @cancel="$emit('onCancel')"
  >
    <a-table
      :columns="columns"
      :data-source="data"
      size="middle"
      :row-key="record => record.id"
      :pagination="false"
    />
  </a-modal>
</template>
<script>
export default {
  props: ['data', 'visible'],
  data() {
    return {
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
        },

        {
          title: '企业名称',
          dataIndex: 'qichacha_name',
        },
        {
          title: '企业类型',
          dataIndex: 'drug_type_name',
        },
        {
          title: '企业电话',
          dataIndex: 'mobile',
        },
      ],
    };
  },
  mounted() {},
  methods: {

  },
};
</script>
<style lang="scss" scoped>

</style>